import React, { useState } from "react";
import { connect } from "react-redux";
import { IState } from "ts/App/reducer";
import { BackgroundOptions } from "../../../../components/pages/CourseAuthor/CourseInstruction/Parts/BackgroundOptions";
import colors from "../../../../../ts/styles/colors";
import LastPartCtx from "../../../../context/last-part";
import { ContentPreviewBox } from "../../../pages/CourseAuthor/CourseInstruction/Parts/ContentPreviewBox";
import InstructionPartHeader from "../../../pages/CourseAuthor/CourseInstruction/Parts/InstructionPartHeader";
import MalformedQuestionWarning from "../../../pages/CourseAuthor/CourseInstruction/Parts/MalformedQuestionWarning";
import { PartComponent } from "../../../pages/CourseAuthor/CourseInstruction/Parts/PartComponent";
import { isGridPart, malformedWarnings } from "../../../pages/CourseAuthor/CourseInstruction/Parts/util";
import { partTitle } from "./CourseInstructionPart.helpers";
import { ICourseInstructionPartProps } from "./CourseInstructionPart.types";
import { isTeachingPart } from "../../../pages/CourseAuthor/CourseInstruction/Parts/util";
import { CancelDragZone } from "../../../../context/UseDragAndDrop";

const CourseInstructionPartComp: React.FC<ICourseInstructionPartProps> = ({
  contentPart,
  currentLocale,
  isOpen,
  partOperations,
  uploadFile,
}) => {
  const containerRef = React.useRef() as React.RefObject<HTMLDivElement>;
  const { lastPart, clearLastPart } = React.useContext(LastPartCtx);
  const messages = malformedWarnings(contentPart, currentLocale);
  const title = partTitle(contentPart);
  const isLastAddedPart = isOpen ? isOpen : lastPart === contentPart.id;
  const [showBackgroundEdit, editShowBackgroundEdit] = useState(false);
  const [{ enableEdit, expanded }, updateState] = useState({
    enableEdit: isLastAddedPart,
    expanded: true,
  });
  const toggleEnableEdit = () => updateState({ enableEdit: !enableEdit, expanded });
  const toggleExpanded = () => updateState({ enableEdit, expanded: !expanded });
  const toggleBackgroundOptions = () => editShowBackgroundEdit(!showBackgroundEdit);

  React.useEffect(() => {
    clearLastPart();
  }, [contentPart.id]);

  return (
    <ContentPreviewBox
      style={{
        backgroundColor: `${colors.white}`,
        borderRadius: "0.5rem",
      }}
      ref={containerRef}
    >
      <CancelDragZone>
        <MalformedQuestionWarning messages={messages} />
      </CancelDragZone>
      <InstructionPartHeader
        part={contentPart}
        deletePart={partOperations.deleteInstructionPart}
        showBackground={showBackgroundEdit}
        edit={enableEdit}
        expanded={expanded}
        title={title}
        toggleEdit={toggleEnableEdit}
        toggleExpanded={toggleExpanded}
        toggleBackgroundOptions={toggleBackgroundOptions}
      />
      <CancelDragZone>
        {showBackgroundEdit && (isTeachingPart(contentPart) || isGridPart(contentPart)) && (
          <BackgroundOptions
            imageId={contentPart.content.background?.imageId ?? null}
            patchBackgroundPart={partOperations.changeBackground}
            uploadFile={uploadFile}
          />
        )}
        {expanded && (
          <PartComponent
            currentLocale={currentLocale}
            edit={enableEdit}
            part={contentPart}
            partOperations={partOperations}
            toggleEdit={toggleEnableEdit}
            containerRef={containerRef}
          />
        )}
      </CancelDragZone>
    </ContentPreviewBox>
  );
};

const mapStateToProps = (state: IState) => ({
  uploadFile: state.App.CourseAuthor._.fileUploadApi.uploadFile,
});

export const CourseInstructionPart = connect(mapStateToProps)(CourseInstructionPartComp);
